<ng-container *ngIf="getForgotPassword(); then forgotPasswordTemplate;"></ng-container>
<ng-template #forgotPasswordTemplate>
  <h1>
    {{'You should receive an email for password reset' | translate}}
  </h1>
</ng-template>

<ng-container *ngIf="getRegistrationForm(); then registrationFormTemplate;"></ng-container>
<ng-template #registrationFormTemplate>
  <h1>
    {{'THANKS FOR YOUR REGISTRATION' | translate}}
  </h1>
  <p>
    {{'We have sent you an email. Please check your inbox.' | translate}}
  </p>
  <p>
    {{'If you have any questions, please contact the support (mySolarlux@solarlux.com)' | translate}}
  </p>
</ng-template>


<ng-container *ngIf="getNewsletterSubscription(); then newsletterSubscriptionTemplate;"></ng-container>
<ng-template #newsletterSubscriptionTemplate>
  <h1 [ngStyle]="{'text-transform': 'uppercase'}">
    {{'thanks for your newsletter registration' | translate}}!
  </h1>
  <p>
    {{'From now on you will receive news about Solarlux' | translate}}.
  </p>
  <p>
    {{'Your team from Solarlux' | translate}}
  </p>
<!--  <button type="button" class="btn btn-info" (click)="goToPortal()" [ngStyle]="{'text-transform': 'uppercase'}">-->
<!--    {{'Go to portal' | translate}}-->
<!--  </button>-->
</ng-template>


<ng-container *ngIf="!getRegistrationForm() && !getForgotPassword() && !getNewsletterSubscription(); then mistakeTemplate;"></ng-container>
<ng-template #mistakeTemplate>
  <h1>
    {{"Are you lost?" | translate}}
  </h1>
  <p>
    {{'If you have any questions, please contact the support (mySolarlux@solarlux.com)' | translate}}
  </p>
</ng-template>
